import React from 'react'
import { Icon } from 'loyal-react'
import PropTypes from 'prop-types'

const ProductShipping = props => (
  <div className='cart-shipping col-12 px-0'>
    <div className='row mx-0 align-items-center h-100'>
      <div className='col-auto'>
        <Icon iconName='icon_truck' className='color-brand-1 icon' />
      </div>
      <div className='col'>
        <div className='col py-half px-0 txt-body-sm'>
          <p className='txt-body-sm'>
            Transportadora: <strong>{props.trackingVtexData.courier}</strong>
          </p>
          <p className='txt-body-sm'>
            Código de rastreamento:{' '}
            <strong>{props.trackingVtexData.trackingNumber}</strong>
          </p>
        </div>
      </div>
      <div className='col-12 col-md-4 pl-half'>
        <button
          onClick={() => {
            window.open(props.trackingVtexData.trackingUrl)
          }}
        >
          Rastrear Pedido
        </button>
      </div>
    </div>
  </div>
)
ProductShipping.prototype = {
  trackingVtexData: PropTypes.object
}
ProductShipping.propTypes = {
  trackingVtexData: PropTypes.any
}
export default ProductShipping



// WEBPACK FOOTER //
// ./src/Participant/MyOrders/ProductOrderDetail/ProductSide/ProductShipping.js